import React, { useState, useEffect,useRef } from "react";
import ReactPaginate from "react-paginate";
import axios from 'axios';
import { getUserId } from '../utils/common';
import Modal from './Modal';
import ModalSale from './ModalSale';
import SubscriptionRenewal from './SubscriptionRenewal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL,auTHURL} from '../utils/common';
import { useReactToPrint } from 'react-to-print';
//import { useDownloadExcel } from "react-export-table-to-excel";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const SubscriptionList = () => {

  const fileType ="xlsx";
  const tableRef = useRef(null);
  const divRef = useRef(null);
  const API_URL=aPIURL();
  const [post, setPost] = useState([]);
  const [order, setOrder] = useState("ASC");
   const [number, setNumber] = useState(1); 
   const [postPerPage] = useState(10);
   const [showAddSaleDevice, setShowAddSaleDevice]= useState(false);
   const [showDetails, setShowDetails]= useState(false);
   const [inputs, setInputs] = useState({});
   const [customerData, setCustomerData]= useState([]);
   const [custID, setCustID]=useState(0);
   const [subscriptionData,setSubscriptionData]= useState([]);
   const [saleSubscriptionTypeID, setSaleSubscriptionTypeID]=useState(0);
   const [dModel, setDModel]=useState("0");
   const [devicestock, setDevicestock]=useState(0);
   const [filteredSaleDeviceDetails,setFilteredSaleDeviceDetails]= useState([]);
   const [saleDeviceData,setSaleDeviceData]= useState([]);
   const [deviceCost,setdeviceCost]=useState(0);
    

useEffect(() => {
      
    FillGrid(0);   
    }, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);
  let rc=1;

const ChangePage = ({ selected }) => {
        setNumber(selected+1);
  };



const showDetailsModal = (index) => {  
    const invoice_ID = index;   
    setShowDetails(true);
           
    const updatedDeviceList = post.filter((custElem) => {          
    
    return custElem.invoiceID === invoice_ID;
  });
   
  setFilteredSaleDeviceDetails(updatedDeviceList);     
   const dcurls=API_URL+`GpsSoldDevicebyId/${invoice_ID}/`;  
   
   axios.get(dcurls).then(response => 
    {                            
      setSaleDeviceData(response.data.data);        
    }).catch(function(error) { console.log(error.message); });  
}
const sorting=(col)=>
{
  try
  {
    if(order==="ASC")
    {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("DSC");
    }
    if(order==="DSC")
    {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("ASC");
    }
  }
  catch(error) 
  {
    console.log(error.message);
  }            
}

const FillGrid=(Type_ID)=>
{
    const curls=API_URL+`GpsSoldDeviceAllList/?TypeID=4`;  
    //alert(curls);
   axios.get(curls).then(response => 
    {                            
        setPost(response.data.data);
        console.log(response.data.data);
        setDevicestock(25);
    }).catch(function(error) { console.log(error.message); });     
    
}

const closeAddSaleModal=()=>
{
        setShowAddSaleDevice(false);
        FillGrid(0);   
}
const closeShowDetailModal=()=>
{
        setShowDetails(false);
        FillGrid(0);   
}
const ChangeCustomerID = (e) => {

         setCustID(e.target.value);
    
}
const ChangeSubscriptionType=(e)=>
{
         setSaleSubscriptionTypeID(e.target.value);
}
const ChangeDMode=(e)=>
{
         setDModel(e.target.value);   
}
const changeVHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({...values, [name]: value}))
}



const exportToCSV=()=>
  {
    const newPost = post.map(({ cgstPer,cgstVal,currency,dueDate,igstPer,igstVal,invDetailID,renewalDate,sgstPer,sgstVal,subscriptionDuration,terms,price, ...rest }) => rest);
     const ws= XLSX.utils.json_to_sheet(newPost);        
     var wscols = [
        {wch:5} ,
        {wch:15},
        {wch:30},
        {wch:15},
        {wch:10},
        {wch:10},
        {wch:20},   
        {wch:20}, 
        {wch:20},  
        {wch:20}
    ];
 
    var wsrows = [
       {hpx: 30}
    ];
    
    ws['!cols'] = wscols;
    ws['!rows']=wsrows;
         
    let Heading = [['S.No.','Invoice ID','Customer Name','Invoice Date','Model','Quantity','Total Amount','Discount','Installation Charge','Grand Total']];
    const wb={Sheets:{DeviceRenewal:ws},SheetNames:["DeviceRenewal"]};
    XLSX.utils.sheet_add_aoa(ws, Heading);     
    const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
    const data= new Blob([excelBuffer],{type:fileType});
    FileSaver.saveAs(data,"AvtDeviceRenewalReport"+".xlsx");
   }

const exportDownload = e => 
{  
    const value = e.target.value; 

if(value=="Excel")
{
      exportToCSV(); 
     //onDownload();
}
if(value=="PDF")
{
      handlePrint(null, () => tableRef.current);
}
}


const printInvoice=()=>
{
  //alert("print");
  handlePrint(null, () => divRef.current);
}


const handlePrint = useReactToPrint({
documentTitle: "Device Details",
onBeforePrint: () => console.log("before printing..."),
onAfterPrint: () => console.log("after printing..."),
removeAfterPrint: true,
});

  return (
    <>
     <ModalSale isOpen={showDetails} style={{height:"800px!important"}}>
      <>
          <div class="modal-header">
            <h5 className='modal-title'>Renewal Details</h5>
            {/*<button type="button" onClick={() => printInvoice()}>Print</button>*/}
            <button type="button" class="btn-close" onClick={closeShowDetailModal}></button>
          </div>
          <div ref={divRef} class="modal-body">
          
          {filteredSaleDeviceDetails.map(devdata1 => (<div className='row' key={devdata1.invoiceID}>
           
            <div className='col-md-6 col-lg-3 form-group'>
                           <b>Invoice No:</b> {devdata1.invDetailID}                           
                             </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Invoice Date:</b> {devdata1.invoiceDate}                            
                            </div>
                            <div className='col-md-6 col-lg-6 form-group'>
                            <b>Customer Name:</b> {devdata1.customerName}                                                       
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Model:</b> {devdata1.model}                            
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Subscription Duration:</b>  {devdata1.subscribeName} 
                            </div>
                            
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Terms:</b> {devdata1.terms} days
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Due Date:</b> {devdata1.dueDate}                            
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Price Per Device:</b> {devdata1.price} {devdata1.currency} 
                            </div>                            
                            <div className='col-md-6 col-lg-3 form-group'>
                            <b>Quantity:</b> {devdata1.quantity}
                            </div> 
                           
            </div>
             ))}
          
            <div className="row" style={{ padding:"5px" }} >           
            <table id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
            <thead>
            <tr>
                    <th style={{ textAlign: "center"}} width="5%">S.No.</th>
                    <th style={{ textAlign: "center"}} width="10%">Device ID</th>
                    <th style={{ textAlign: "center"}} width="10%">Name</th>                   
                    <th style={{ textAlign: "center"}} width="30%">IMEI#</th>
                    <th style={{ textAlign: "center"}} width="30%">SIM#</th>
                    <th style={{ textAlign: "center"}} width="30%">Expiry Date</th>         
                    
            </tr>
            </thead>
            <tbody>
                {saleDeviceData.map(item => (                    
                <tr key={item.id}>
                  <td style={{ textAlign: "center"}}> {item.sno}</td>
                  <td style={{ textAlign: "center"}}>{item.id}</td>
                  <td>{item.deviceName}</td>                  
                  <td>{item.imeiNumber}</td>
                  <td style={{ textAlign: "center"}}> {item.mobileNumber} </td>
                  <td>{item.expiryDate}</td>
                  <td style={{"display":"none"}}>{rc++}    </td>     
                </tr>
                 
                    ))}                
            </tbody>
            </table>
            </div>
            {filteredSaleDeviceDetails.map(devdata1 => (<div className='row' key={devdata1.invoiceID}>
           
                           <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>Total Amount:</b> 
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                             {devdata1.totalAmount}
                            </div> 
                            <div className='col-md-6 col-lg-1 form-group' ></div> 
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>Discount:</b> 
                            </div> 
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                             {devdata1.discount}
                            </div> 
                            <div className='col-md-6 col-lg-1 form-group' ></div>
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>Installation Charge:</b> 
                            </div>   
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                            {devdata1.installationCharge}
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' ></div>
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>CGST:</b>&nbsp;&nbsp;({devdata1.cgstPer}%) 
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                             {devdata1.cgstVal}
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' ></div>
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>SGST:</b>&nbsp;&nbsp;({devdata1.sgstPer}%) 
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                            {devdata1.sgstVal}
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' ></div>
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>IGST:</b>&nbsp;&nbsp;({devdata1.igstPer}%) 
                            </div>   
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                            {devdata1.igstVal}
                            </div>   
                            <div className='col-md-6 col-lg-1 form-group' ></div>
                            <hr/>
                            <div className='col-md-6 col-lg-8 form-group'>
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            <b>Grand Total:</b> 
                            </div> 
                            
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"right"}}>
                            <b>{devdata1.grandTotal}</b>
                            </div>  
                            <div className='col-md-6 col-lg-1 form-group' style={{textAlign:"left"}}></div>                         
            </div>
             ))}
 
          </div>                    
        </>
      </ModalSale>  
    
      <div className="top-bar clearfix">
        <div className="row">
          <div className="col-md-4">
            <h2> Renewal Device</h2>              
          </div>
          <div className="col-md-8 text-right">
          
            
            <select onChange={exportDownload} className="btn btn-primary" name="Download" >
            <option value={"Download"}>Download</option>    
            <option value={"Excel"}>Excel</option>    
             <option value={"PDF"}>PDF</option>                      
            </select>

          </div>

        </div>
      
    </div>
    <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body p-0">
        <table ref={tableRef} id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
    <thead>
    <tr>
                    <th width="3%" >S.No.</th>
                    <th onClick={()=>sorting("invDetailID") } style={{textAlign:"center","cursor": "pointer"}} width="10%">Invoice ID &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("customerName") } style={{textAlign:"center","cursor": "pointer"}} width="10%">Customer Name &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("invoiceDate") } style={{textAlign:"center","cursor": "pointer"}} width="10%">Invoice Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("quantity") } style={{textAlign:"center","cursor": "pointer"}} width="10%">Quantity &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("model") } style={{textAlign:"center","cursor": "pointer"}} width="7%">Model &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("totalAmount") } style={{textAlign:"center","cursor": "pointer"}} width="10%">Total Amount &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("discount") } style={{textAlign:"center","cursor": "pointer"}} width="10%">Discount &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("installationCharge") } style={{textAlign:"center","cursor": "pointer"}} width="13%">Installation Charge &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th onClick={()=>sorting("grandTotal") } style={{textAlign:"center","cursor": "pointer"}} width="10%">Grand Total &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                    <th style={{textAlign:"center"}} width="7%">Action</th>
    </tr>
    </thead>
    <tbody>
    {currentPost.map((item) => {
                return (
                <tr key={item.invoiceID}>
                  <td style={{textAlign:"center"}}>{item.sNo}</td>
                  <td style={{textAlign:"center"}}>{item.invDetailID}</td>
                  <td>{item.customerName}</td>
                  <td style={{textAlign:"center"}}>{item.invoiceDate}</td>
                  <td style={{textAlign: "center"}}>{item.quantity}</td>
                  <td style={{textAlign:"center"}}>{item.model}</td>
                  <td style={{textAlign:"center"}}>{item.totalAmount}</td>
                  <td style={{textAlign:"center"}}>{item.discount}</td>
                  <td style={{textAlign:"center"}}>{item.installationCharge}</td>
                  <td style={{textAlign:"center"}}>{item.grandTotal}</td>
                  <td style={{textAlign:"center", fontSize:"16px"}}>
                  <i onClick={() => showDetailsModal(item.invoiceID)} style={{ color:"green", cursor:'pointer'}} className="fas fa-list" title="View Details"></i>
                  </td>
                </tr>
               );
              })}                 
                </tbody>
            </table>
            <ReactPaginate previousLabel={"<<"} nextLabel={">>"} pageCount={PageCount}
            onPageChange={ChangePage} disableInitialCallback={true} initialPage={0} containerClassName={'pagination justify-content-end'}
            pageClassName={'page-item'} pageLinkClassName={'page-link'} previousClassName={'page-item'} previousLinkClassName={'page-link'}  nextClassName={'page-item'}
            nextLinkClassName={'page-link'} breakClassName={'page-item'} breakLinkClassName={'page-link'} activeClassName={'active'}>
            </ReactPaginate>
        </div>
      </div></div>
      <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
    </>
  );
};

  
export default SubscriptionList;